(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pf-announcement-bar').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.scrollThreshold, 10) || 24;
      var lastY = window.scrollY;

      function setOffset() {
        var visible = bar.dataset.hidden !== 'true';
        var height = visible ? bar.offsetHeight : 0;
        document.documentElement.style.setProperty('--pf-announcement-offset', height + 'px');
      }

      function update() {
        var currentY = window.scrollY;
        var delta = currentY - lastY;

        if (currentY <= threshold) {
          bar.dataset.hidden = 'false';
        } else if (delta > 4) {
          bar.dataset.hidden = 'true';
        } else if (delta < -4) {
          bar.dataset.hidden = 'false';
        }

        setOffset();
        lastY = currentY;
      }

      var ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(function () {
              update();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );

      window.addEventListener('resize', setOffset);
      setOffset();

      var countdownEl = bar.querySelector('[data-countdown]');
      if (countdownEl) {
        var endTime = new Date(countdownEl.dataset.countdownEnd).getTime();
        var hoursEl = countdownEl.querySelector('[data-cd-hours]');
        var minutesEl = countdownEl.querySelector('[data-cd-minutes]');
        var secondsEl = countdownEl.querySelector('[data-cd-seconds]');
        var intervalId;

        function pad(value) {
          return value < 10 ? '0' + value : String(value);
        }

        function tick() {
          var remaining = endTime - Date.now();
          if (isNaN(endTime) || remaining <= 0) {
            countdownEl.hidden = true;
            if (intervalId) clearInterval(intervalId);
            setOffset();
            return;
          }
          var totalSeconds = Math.floor(remaining / 1000);
          var hours = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds % 3600) / 60);
          var seconds = totalSeconds % 60;
          if (hoursEl) hoursEl.textContent = hours;
          if (minutesEl) minutesEl.textContent = pad(minutes);
          if (secondsEl) secondsEl.textContent = pad(seconds);
        }

        tick();
        intervalId = setInterval(tick, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-brand-grid-full"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pf-bgf__az-nav').forEach(function (navEl) {
    var sid = navEl.id.replace('pf-bgf-az-', '');
    var sectionsEl = document.getElementById('pf-bgf-sections-' + sid);
    var emptyEl    = document.getElementById('pf-bgf-empty-'    + sid);
    var searchEl   = document.getElementById('pf-bgf-search-'   + sid);

    /* Offset sticky nav below the site header */
    var header = document.getElementById('pf-header');
    function setNavTop() {
      if (header) navEl.style.top = header.offsetHeight + 'px';
    }
    setNavTop();
    window.addEventListener('resize', setNavTop);

    /* Set scroll-margin-top on each letter section to match nav height */
    function setScrollMargins() {
      var navH = (header ? header.offsetHeight : 0) + navEl.offsetHeight;
      if (sectionsEl) {
        sectionsEl.querySelectorAll('.pf-bgf__letter-section').forEach(function (s) {
          s.style.scrollMarginTop = (navH + 8) + 'px';
        });
      }
    }
    setScrollMargins();
    window.addEventListener('resize', setScrollMargins);

    /* A-Z nav click → scroll to section */
    navEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.pf-bgf__az-btn');
      if (!btn || btn.disabled) return;
      var target = document.getElementById(btn.dataset.azTarget);
      if (!target) return;
      var navH  = (header ? header.offsetHeight : 0) + navEl.offsetHeight + 8;
      var top   = window.scrollY + target.getBoundingClientRect().top - navH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    /* Highlight active letter via IntersectionObserver */
    if (sectionsEl && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var letter = entry.target.dataset.letter;
          navEl.querySelectorAll('.pf-bgf__az-btn').forEach(function (b) {
            b.classList.toggle('pf-bgf__az-btn--active', b.textContent.trim() === letter);
          });
        });
      }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });
      sectionsEl.querySelectorAll('.pf-bgf__letter-section').forEach(function (s) { obs.observe(s); });
    }

    /* Search */
    if (searchEl && sectionsEl) {
      searchEl.addEventListener('input', function () {
        var q = searchEl.value.trim().toLowerCase();
        var hasQ = q.length > 0;
        navEl.hidden = hasQ;

        var totalVisible = 0;
        sectionsEl.querySelectorAll('.pf-bgf__letter-section').forEach(function (sec) {
          var sectionVisible = 0;
          sec.querySelectorAll('.pf-bgf__item').forEach(function (item) {
            var match = !hasQ || (item.dataset.name || '').indexOf(q) !== -1;
            item.hidden = !match;
            if (match) sectionVisible++;
          });
          sec.hidden = sectionVisible === 0;
          totalVisible += sectionVisible;
        });

        if (emptyEl) emptyEl.hidden = totalVisible > 0 || !hasQ;
      });
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-brand-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pf-bg__search-input').forEach(function (input) {
    var sid = input.id.replace('pf-bg-search-', '');
    var grid = document.getElementById('pf-bg-grid-' + sid);
    var empty = document.getElementById('pf-bg-empty-' + sid);
    if (!grid) return;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var items = grid.querySelectorAll('.pf-bg__item');
      var visible = 0;
      items.forEach(function (item) {
        var match = !q || (item.dataset.name || '').indexOf(q) !== -1;
        item.hidden = !match;
        if (match) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-discovery-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.pfDsArrows = function (sectionId, scrollEl) {
      var container = document.getElementById('pf-ds-' + sectionId);
      if (!container) return;
      var left  = container.querySelector('.pf-ds-arrow--left');
      var right = container.querySelector('.pf-ds-arrow--right');
      if (!left || !right) return;

      var canLeft  = scrollEl.scrollLeft > 4;
      var canRight = scrollEl.scrollLeft + scrollEl.clientWidth < scrollEl.scrollWidth - 4;
      left.classList.toggle('visible', canLeft);
      right.classList.toggle('visible', canRight);
    };

    document.querySelectorAll('.pf-ds-scroll').forEach(function (scroll) {
      var container = scroll.closest('.pf-ds');
      if (!container) return;
      pfDsArrows(container.id.replace('pf-ds-', ''), scroll);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-shipping-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pf-shipmap').forEach(function (root) {
      var dataEl = root.querySelector('script[data-shipmap-json]');
      var data = {};
      if (dataEl) {
        try {
          data = JSON.parse(dataEl.textContent.trim());
        } catch (e) {
          data = {};
        }
      }

      var svg = root.querySelector('.pf-shipmap__svg');
      var mapWrap = root.querySelector('.pf-shipmap__map-wrap');
      var tooltipEl = root.querySelector('.pf-shipmap__tooltip');
      if (!svg) return;

      var groupToCodes = {};
      Object.keys(data).forEach(function (code) {
        var entry = data[code];
        var pathEl = svg.querySelector('[data-country="' + code + '"]');
        if (!pathEl) return;
        pathEl.classList.add('is-shipped');
        pathEl.style.setProperty('--pf-shipmap-group-color', entry.color);
        var titleEl = pathEl.querySelector('title');
        if (titleEl) titleEl.textContent = entry.name + ' — ' + entry.time;

        if (!groupToCodes[entry.group]) groupToCodes[entry.group] = [];
        groupToCodes[entry.group].push(code);
      });

      var pinnedCode = null;

      function highlight(code, on) {
        var entry = data[code];
        if (!entry) return;
        var siblings = groupToCodes[entry.group] || [code];
        siblings.forEach(function (siblingCode) {
          var el = svg.querySelector('[data-country="' + siblingCode + '"]');
          if (el) el.classList.toggle('is-active', on);
        });
        var legendEl = root.querySelector('.pf-shipmap-legend-item[data-group="' + entry.group + '"]');
        if (legendEl) legendEl.classList.toggle('is-active', on);
      }

      function moveTooltip(clientX, clientY) {
        if (!tooltipEl || !mapWrap) return;
        var wrapRect = mapWrap.getBoundingClientRect();
        var x = clientX - wrapRect.left;
        var y = clientY - wrapRect.top;

        var tw = tooltipEl.offsetWidth;
        var th = tooltipEl.offsetHeight;
        var minX = tw / 2 + 4;
        var maxX = wrapRect.width - tw / 2 - 4;
        if (x < minX) x = minX;
        if (x > maxX) x = maxX;

        tooltipEl.classList.toggle('pf-shipmap__tooltip--below', y - th - 12 < 0);
        tooltipEl.style.left = x + 'px';
        tooltipEl.style.top = y + 'px';
      }

      function showTooltip(code, clientX, clientY) {
        var entry = data[code];
        if (!entry || !tooltipEl) return;
        tooltipEl.textContent = entry.name + ' — ' + entry.time;
        tooltipEl.style.setProperty('--pf-shipmap-group-color', entry.color);
        tooltipEl.classList.add('is-visible');
        moveTooltip(clientX, clientY);
      }

      function hideTooltip() {
        if (!tooltipEl) return;
        tooltipEl.classList.remove('is-visible');
      }

      svg.addEventListener('pointerover', function (e) {
        var pathEl = e.target.closest('.pf-shipmap-country.is-shipped');
        if (!pathEl) return;
        var code = pathEl.dataset.country;
        highlight(code, true);
        if (!pinnedCode) showTooltip(code, e.clientX, e.clientY);
      });
      svg.addEventListener('pointermove', function (e) {
        if (pinnedCode) return;
        var pathEl = e.target.closest('.pf-shipmap-country.is-shipped');
        if (!pathEl) return;
        moveTooltip(e.clientX, e.clientY);
      });
      svg.addEventListener('pointerout', function (e) {
        var pathEl = e.target.closest('.pf-shipmap-country.is-shipped');
        if (!pathEl) return;
        highlight(pathEl.dataset.country, false);
        if (!pinnedCode) hideTooltip();
      });
      svg.addEventListener('click', function (e) {
        var pathEl = e.target.closest('.pf-shipmap-country.is-shipped');
        if (!pathEl) return;
        var code = pathEl.dataset.country;
        if (pinnedCode === code) {
          highlight(code, false);
          pinnedCode = null;
          hideTooltip();
        } else {
          if (pinnedCode) highlight(pinnedCode, false);
          pinnedCode = code;
          highlight(code, true);
          showTooltip(code, e.clientX, e.clientY);
        }
      });

      document.addEventListener('click', function (e) {
        if (pinnedCode && !root.contains(e.target)) {
          highlight(pinnedCode, false);
          pinnedCode = null;
          hideTooltip();
        }
      });

      var legendList = root.querySelector('.pf-shipmap__legend-list');
      if (legendList) {
        legendList.addEventListener('pointerover', function (e) {
          var item = e.target.closest('.pf-shipmap-legend-item');
          if (!item) return;
          var codes = groupToCodes[item.dataset.group] || [];
          if (codes[0]) highlight(codes[0], true);
        });
        legendList.addEventListener('pointerout', function (e) {
          var item = e.target.closest('.pf-shipmap-legend-item');
          if (!item) return;
          var codes = groupToCodes[item.dataset.group] || [];
          if (codes[0]) highlight(codes[0], false);
        });
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-tabbed-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Recommendations loader ── */
    document.querySelectorAll('.pf-tc[data-product-id]').forEach(function (el) {
      var productId  = el.dataset.productId;
      var sectionId  = el.dataset.sectionId;
      var intent     = el.dataset.intent || 'related';
      var limit      = el.dataset.limit  || 10;

      if (!productId || !sectionId) return;

      var url = '/recommendations/products?section_id=' + sectionId
              + '&product_id=' + productId
              + '&limit=' + limit
              + '&intent=' + intent;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc  = new DOMParser().parseFromString(html, 'text/html');
          var src  = doc.getElementById('pf-tc-recs-' + sectionId);
          var dest = document.getElementById('pf-tc-scroll-tab1-' + sectionId);
          if (!src || !dest) return;

          dest.innerHTML = src.innerHTML;
          pfTcArrows(sectionId, 'tab1', dest);
        })
        .catch(function () {});
    });

    /* ── Tab switching ── */
    window.pfTcSwitch = function (btn, sectionId, tabId) {
      var container = document.getElementById('pf-tc-' + sectionId);
      if (!container) return;

      container.querySelectorAll('.pf-tc-tab').forEach(function (t) { t.classList.remove('active'); });
      container.querySelectorAll('.pf-tc-panel').forEach(function (p) { p.classList.remove('active'); });

      btn.classList.add('active');
      var panel = document.getElementById('pf-tc-panel-' + tabId + '-' + sectionId);
      if (panel) {
        panel.classList.add('active');
        var scroll = panel.querySelector('.pf-tc-scroll');
        if (scroll) pfTcArrows(sectionId, tabId, scroll);
      }
    };

    /* ── Arrow visibility ── */
    window.pfTcArrows = function (sectionId, tabId, scrollEl) {
      var panel = document.getElementById('pf-tc-panel-' + tabId + '-' + sectionId);
      if (!panel) return;
      var left  = panel.querySelector('.pf-tc-arrow--left');
      var right = panel.querySelector('.pf-tc-arrow--right');
      if (!left || !right) return;

      var canLeft  = scrollEl.scrollLeft > 4;
      var canRight = scrollEl.scrollLeft + scrollEl.clientWidth < scrollEl.scrollWidth - 4;
      left.classList.toggle('visible', canLeft);
      right.classList.toggle('visible', canRight);
    };

    /* Initial arrow check for all visible panels */
    document.querySelectorAll('.pf-tc-panel.active .pf-tc-scroll').forEach(function (scroll) {
      var panel     = scroll.closest('.pf-tc-panel');
      var container = scroll.closest('.pf-tc');
      if (!panel || !container) return;
      var sectionId = container.dataset.sectionId;
      var tabId     = panel.id.replace('pf-tc-panel-', '').replace('-' + sectionId, '');
      pfTcArrows(sectionId, tabId, scroll);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.pfCtcSwitch = function (btn, sectionId, colId) {
      var container = document.getElementById('pf-ctc-' + sectionId);
      if (!container) return;

      container.querySelectorAll('.pf-ctc-tab').forEach(function (t) { t.classList.remove('active'); });
      container.querySelectorAll('.pf-ctc-panel').forEach(function (p) { p.classList.remove('active'); });

      btn.classList.add('active');
      var panel = document.getElementById('pf-ctc-panel-' + colId + '-' + sectionId);
      if (panel) {
        panel.classList.add('active');
        var scroll = panel.querySelector('.pf-ctc-scroll');
        if (scroll) pfCtcArrows(sectionId, colId, scroll);
      }
    };

    window.pfCtcArrows = function (sectionId, colId, scrollEl) {
      var panel = document.getElementById('pf-ctc-panel-' + colId + '-' + sectionId);
      if (!panel) return;
      var left  = panel.querySelector('.pf-ctc-arrow--left');
      var right = panel.querySelector('.pf-ctc-arrow--right');
      if (!left || !right) return;

      left.classList.toggle('visible',  scrollEl.scrollLeft > 4);
      right.classList.toggle('visible', scrollEl.scrollLeft + scrollEl.clientWidth < scrollEl.scrollWidth - 4);
    };

    document.querySelectorAll('.pf-ctc-panel.active .pf-ctc-scroll').forEach(function (scroll) {
      var panel     = scroll.closest('.pf-ctc-panel');
      var container = scroll.closest('.pf-ctc');
      if (!panel || !container) return;
      var sectionId = container.id.replace('pf-ctc-', '');
      var colId     = panel.id.replace('pf-ctc-panel-', '').replace('-' + sectionId, '');
      pfCtcArrows(sectionId, colId, scroll);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pf-test__gallery').forEach(function (gallery) {
      gallery.querySelectorAll('[data-video-tile]').forEach(function (tile) {
        var video = tile.querySelector('video');
        var playIcon = tile.querySelector('[data-play-icon]');
        var pauseIcon = tile.querySelector('[data-pause-icon]');
        if (!video) return;

        tile.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            if (playIcon) playIcon.hidden = true;
            if (pauseIcon) pauseIcon.hidden = false;
          } else {
            video.pause();
            if (playIcon) playIcon.hidden = false;
            if (pauseIcon) pauseIcon.hidden = true;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    // Sticky add-to-cart's compact variant selector is a proxy: selecting an
    // option here finds the matching input in the real variant-picker (up in
    // the main product form) and drives it, so the site's one existing,
    // battle-tested variant-change flow (price/media/URL/cart button update,
    // plus this sticky bar re-rendering itself) stays the single source of
    // truth instead of two independent pickers going out of sync.
    // Delegated on document since the sticky bar's own markup gets replaced
    // (morphed) whenever the variant changes.
    document.addEventListener('change', function (event) {
      var select = event.target.closest('.sticky-variant-select');
      if (!select) return;

      var selectedOption = select.options[select.selectedIndex];
      var optionValueId = selectedOption && selectedOption.dataset.optionValueId;
      if (!optionValueId) return;

      var mainInput = document.querySelector('variant-picker [data-option-value-id="' + optionValueId + '"]');
      if (!mainInput) return;

      if (mainInput.tagName === 'INPUT') {
        if (mainInput.checked) return;
        mainInput.checked = true;
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (mainInput.tagName === 'OPTION') {
        var mainSelect = mainInput.closest('select');
        if (mainSelect && mainSelect.value !== mainInput.value) {
          mainSelect.value = mainInput.value;
          mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
